import { render, staticRenderFns } from "./PricePanels.vue?vue&type=template&id=6854e9a2&"
import script from "./PricePanels.vue?vue&type=script&lang=js&"
export * from "./PricePanels.vue?vue&type=script&lang=js&"
import style0 from "./PricePanels.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VExpansionPanels,VIcon,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/working_dir/management-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6854e9a2')) {
      api.createRecord('6854e9a2', component.options)
    } else {
      api.reload('6854e9a2', component.options)
    }
    module.hot.accept("./PricePanels.vue?vue&type=template&id=6854e9a2&", function () {
      api.rerender('6854e9a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Pricing/PricePanels.vue"
export default component.exports